/*
 * Cork Haven — motion layer
 *
 * Reformation already ships GSAP 3 + ScrollTrigger (vendor.min.js /
 * animations.min.js) but no section opts into them, which is why the site
 * reads static despite "Enable animations" being on. This drives the existing
 * engine rather than shipping a second one.
 *
 * Safety: elements are only hidden immediately before their ScrollTrigger is
 * created, inside a try/catch, with a watchdog that restores everything if
 * anything goes wrong. A broken animation must never mean invisible content.
 */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var HIDDEN = [];   // everything we've set opacity:0 on, for the watchdog
  var started = false;

  function restoreAll() {
    if (!window.gsap) {
      HIDDEN.forEach(function (el) {
        el.style.opacity = '';
        el.style.transform = '';
      });
    } else {
      window.gsap.set(HIDDEN, { clearProps: 'opacity,transform' });
    }
    HIDDEN.length = 0;
  }

  function collect(section) {
    var out = [];
    var grids = section.querySelectorAll('.collection-grid, .product-grid, .thb-product-list');
    for (var g = 0; g < grids.length; g++) {
      var kids = grids[g].children;
      for (var k = 0; k < kids.length; k++) out.push(kids[k]);
    }
    if (!out.length) {
      var text = section.querySelectorAll('.section-header, .rte, .thb-section-header');
      for (var t = 0; t < text.length; t++) out.push(text[t]);
    }
    return out.filter(function (el) {
      if (el.dataset.chDone) return false;
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0;   // never hide something with no box
    });
  }

  function animate() {
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    if (!gsap || !ST) return false;

    gsap.registerPlugin(ST);

    var main = document.getElementById('main-content');
    if (!main) return true;

    var sections = main.querySelectorAll(':scope > .shopify-section');

    Array.prototype.forEach.call(sections, function (section, si) {
      // The hero is on screen at load; it gets its own intro below.
      if (si === 0) return;

      var targets = collect(section);
      if (!targets.length) return;

      targets.forEach(function (el) { el.dataset.chDone = '1'; });
      gsap.set(targets, { opacity: 0, y: 30 });
      HIDDEN = HIDDEN.concat(targets);

      ST.batch(targets, {
        start: 'top 88%',
        once: true,
        onEnter: function (els) {
          gsap.to(els, {
            opacity: 1,
            y: 0,
            duration: 0.9,
            ease: 'power3.out',
            stagger: 0.07,
            overwrite: 'auto'
          });
        }
      });
    });

    /* Hero intro. The headline resolves word by word out of a blur, which is
       the one piece of motion carrying the top of the page; everything else
       up here stays still so it reads composed rather than busy. */
    var hero = main.querySelector(':scope > .shopify-section .slideshow__slide');
    if (hero && !hero.dataset.chIntro) {
      hero.dataset.chIntro = '1';

      var heading = hero.querySelector('h1, .slideshow__heading');
      var words = null;

      if (heading && !heading.dataset.chSplit && !heading.querySelector('img, svg')) {
        var text = heading.textContent.replace(/\s+/g, ' ').trim();
        if (text && text.length < 120) {
          heading.dataset.chSplit = '1';
          heading.setAttribute('aria-label', text);
          heading.textContent = '';
          text.split(' ').forEach(function (w, i, arr) {
            var span = document.createElement('span');
            span.className = 'ch-word';
            span.setAttribute('aria-hidden', 'true');
            span.textContent = w + (i < arr.length - 1 ? ' ' : '');
            heading.appendChild(span);
          });
          words = heading.querySelectorAll('.ch-word');
        }
      }

      var tl = gsap.timeline({ delay: 0.12 });

      var eyebrow = hero.querySelector('.subheading, .slideshow__subheading');
      if (eyebrow) tl.from(eyebrow, { opacity: 0, y: 12, duration: 0.7, ease: 'power2.out' }, 0);

      if (words && words.length) {
        tl.from(words, {
          opacity: 0,
          yPercent: 42,
          filter: 'blur(9px)',
          duration: 1.05,
          ease: 'power3.out',
          stagger: 0.055
        }, 0.06);
      } else if (heading) {
        tl.from(heading, { opacity: 0, y: 24, duration: 1, ease: 'power3.out' }, 0.06);
      }

      var cta = hero.querySelectorAll('.button');
      if (cta.length) tl.from(cta, { opacity: 0, y: 16, duration: 0.7, ease: 'power2.out', stagger: 0.08 }, 0.42);
    }

    /* Slow parallax drift on hero footage as you scroll away from it. */
    var heroBg = main.querySelector(':scope > .shopify-section .slideshow__slide-bg');
    if (heroBg && !heroBg.dataset.chParallax) {
      heroBg.dataset.chParallax = '1';
      gsap.to(heroBg, {
        yPercent: 12,
        ease: 'none',
        scrollTrigger: { trigger: heroBg, start: 'top top', end: 'bottom top', scrub: true }
      });
    }

    ST.refresh();
    return true;
  }

  /* ---------------------------------------------------------------------
     Header: recede on scroll down, return on scroll up.
     --------------------------------------------------------------------- */
  function header() {
    var el = document.querySelector('.header-section');
    if (!el || el.dataset.chNav) return;
    el.dataset.chNav = '1';

    var lastY = window.pageYOffset;
    var ticking = false;
    var THRESHOLD = 6;      // ignore sub-pixel jitter and rubber-banding
    var KEEP_OPEN_ABOVE = 140;

    function onScroll() {
      var y = window.pageYOffset;
      var delta = y - lastY;
      el.classList.toggle('nav-stuck', y > 8);

      if (Math.abs(delta) > THRESHOLD) {
        var menuOpen = document.querySelector('.mobile-toggle-wrapper[open]');
        if (delta > 0 && y > KEEP_OPEN_ABOVE && !menuOpen) el.classList.add('nav-hidden');
        else if (delta < 0) el.classList.remove('nav-hidden');
        lastY = y;
      }
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(onScroll);
    }, { passive: true });
  }


  function run() {
    try {
      started = animate();
    } catch (e) {
      if (window.console) console.warn('[cork-haven] motion layer failed, restoring:', e);
      restoreAll();
    }
  }

  function init() {
    header();

    // Never stage content at opacity 0 while the page isn't rendering.
    // A hidden tab gets no requestAnimationFrame, so GSAP's ticker never
    // advances and the tweens would sit queued with the content invisible —
    // which is also how a crawler or a prerender would see it. Wait for the
    // document to actually be visible before hiding anything.
    if (document.hidden) {
      document.addEventListener('visibilitychange', function onVis() {
        if (document.hidden) return;
        document.removeEventListener('visibilitychange', onVis);
        run();
      });
      return;
    }
    run();
  }

  // Watchdog: if GSAP never showed up, or tweens were staged but the ticker
  // never advanced, reveal everything rather than leaving content invisible.
  window.addEventListener('load', function () {
    setTimeout(function () {
      if (!started || !window.gsap) { restoreAll(); return; }
      if (document.hidden) return;                 // will run on visibilitychange
      if (window.gsap.ticker.frame < 2) restoreAll();
    }, 1500);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
